import store from "@/store";
import {errorHandler} from "@/services/errorHandler";
import router from "@/router";

export const responses = {
    throwErr(err, title = `Oops`) {
        return Swal.fire({
            title: title,
            icon: `warning`,
            html: `<p>${err}</p>`,
            showCloseButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false
        })
    },

    showSuccess(msg) {
        return Toast.fire({
            icon: 'success',
            title: msg
        });
    },

    showInfo(msg) {
        return Toast.fire({
            icon: 'info',
            title: msg
        });
    },

    async deviceErr(err, title = `An Error Occurred`) {
        await store.dispatch('fetchResetCount')
        let count = store.getters.getResetCount;
        return Swal.fire({
            title: `Registration Error`,
            icon: 'warning',
            html: `
            <span>${err}</span><br/>
            <br/>
            <span>Number Of Reset Count(s): ${count.resets}</span><br/>
            <span>Remaining Resets Count(s): ${count.remainingResets}</span>
        `,
            stopKeydownPropagation: true,
            confirmButtonText: 'Reset Device',
            allowOutsideClick: false,
            allowEscapeKey: false
        }).then((result) => {
            if (result.isConfirmed) {
                return Swal.fire({
                    title: "Enter Your Name",
                    input: "text",
                    confirmButtonText: 'Reset',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showLoaderOnConfirm: true,
                    stopKeydownPropagation: true,
                    preConfirm: (name) => {
                        if (!name) {
                            Swal.showValidationMessage('Name is required');
                            return false;
                        }
                        return store.dispatch('ResetDevices', name)
                            .catch(async (err) => {
                                errorHandler.tomcatError(err);
                                const result = await Swal.fire({
                                    title: 'Device Reset Failed',
                                    icon: 'error',
                                    html: '<p>Device reset failed. Please purchase license or switch store.</p>',
                                    showCancelButton: true,
                                    confirmButtonText: 'Make Payment',
                                    cancelButtonText: 'Switch Store',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                });
                                
                                if (result.isConfirmed) {
                                    // Navigate to payment screen
                                    await store.dispatch('getDueInvoices')
                                        .then(res => {
                                            if (res && res.id) {
                                                window.open('https://subscription.chrilantech.com/?reference=' + res.id);
                                            }
                                        })
                                        .catch(err => {
                                            errorHandler.tomcatError(err);
                                        });
                                } else if (result.dismiss === Swal.DismissReason.cancel) {
                                    // Navigate to store selection
                                    router.push({name: 'setup'});
                                }
                                return false;
                            });
                    }
                }).then((finalResult) => {
                    if (finalResult.isConfirmed) {
                        return Swal.fire({
                            title: "Devices Reset",
                            icon: "success",
                            text: "Your license have been reset successfully!. Please login again",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            stopKeydownPropagation: true
                        });
                    }
                });
            }
        });
    },

    showWarning(msg, timer = 1500) {
        return Toast.fire({
            icon: 'warning',
            title: msg,
            timer: timer
        });
    },
}
